import * as React from 'react'

import { Avatar, Box, Icon, Text } from '@factorialco/deprecated-design-system'

import UserAvatar from 'modules/core/components/UserAvatar'
import i18n from 'modules/core/lib/i18n'
import type User from 'modules/core/store/models/User'

import type QuestionGroupActor from 'modules/reviews/store/models/QuestionGroupActor'

function AnonymousPlaceholderLabel() {
  return (
    <Box>
      <Box flexDirection="row" gap="s16" alignItems="center">
        <Avatar label={i18n.t('common.anonymous_user')} />
        <Text.Normal>{i18n.t('common.anonymous_user')}</Text.Normal>
      </Box>
    </Box>
  )
}

interface UserProps {
  user: User | QuestionGroupActor
  description?: string | null | undefined
}

function UserLabel({ user, description }: UserProps) {
  return (
    <Box flexDirection="row" gap="s16">
      <UserAvatar user={user} size="s40" />
      <Box justifyContent="center">
        <Text.Normal size="300" weight="medium">
          {user.fullName()}
        </Text.Normal>
        {description && (
          <Text.Normal size="200" color="grey800">
            {description}
          </Text.Normal>
        )}
      </Box>
    </Box>
  )
}

interface Props {
  description?: string | null | undefined
  respondent?: QuestionGroupActor | null | undefined
  target?: QuestionGroupActor | null | undefined
  targetDescription?: string | null | undefined
  ariaLabel?: string | undefined
}

export default function ReviewUserTargetBlock({
  children,
  description,
  respondent,
  target,
  targetDescription,
  ariaLabel,
}: React.PropsWithChildren<Props>) {
  return (
    <Box
      overflowY="hidden"
      overflowX="hidden"
      borderRadius={{
        all: 'abs008',
      }}
      border={{
        all: {
          style: 'solid',
          width: 's1',
          color: 'grey400',
        },
      }}
      aria-label={ariaLabel}
    >
      <Box
        background="grey000White"
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
        paddingX="s16"
        paddingY="s24"
        gap="s16"
        border={{
          bottom: {
            style: 'solid',
            width: 's1',
            color: 'grey400',
          },
        }}
      >
        {respondent && <UserLabel user={respondent} description={description} />}
        {!respondent && <AnonymousPlaceholderLabel />}
        {target && (
          <>
            <Icon.Medium icon="arrow-right" />
            <UserLabel user={target} description={targetDescription} />
          </>
        )}
      </Box>
      <Box
        background="grey100"
        borderRadius={{
          bottomRight: 'abs008',
          bottomLeft: 'abs008',
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
